const preloaded = new Set();

/**
 * Preload images so they're cached before the user needs them.
 * @param {string[]} urls - Already-resolved image URLs (e.g. from ES imports)
 * @param {{ strategy?: 'link' | 'image' | 'fetch' }} options
 *   - 'link': <link rel="preload"> — high priority, for above-the-fold images
 *   - 'image': new Image() — background download, for upcoming screens
 *   - 'fetch': <link rel="preload" as="fetch"> — for JSON/non-image assets
 */
export function preloadImages(urls, { strategy = 'image' } = {}) {
  if (typeof document === 'undefined') return;

  urls.forEach((url) => {
    if (preloaded.has(url)) return;
    preloaded.add(url);

    if (strategy === 'link' || strategy === 'fetch') {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = strategy === 'fetch' ? 'fetch' : 'image';
      link.href = url;
      if (strategy === 'fetch') link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    } else {
      new Image().src = url;
    }
  });
}
